import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Landing from './pages/Landing'
import Inscription from './pages/Inscription'
import Connexion from './pages/Connexion'
import MotDePasseOublie from './pages/MotDePasseOublie'
import TableauDeBord from './pages/TableauDeBord'
import PageEnfant from './pages/PageEnfant'
import AccesEcole from './pages/AccesEcole'
import PageEcole from './pages/PageEcole'
import AccesEtendu from './pages/AccesEtendu'
import PageTherapeutique from './pages/PageTherapeutique'
import Annuaire from './pages/Annuaire'
import MentionsLegales from './pages/MentionsLegales'
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite'
import InscriptionPro from './pages/InscriptionPro'
import ValiderPro from './pages/ValiderPro'
import DashboardPro, { ConnexionPro } from './pages/ProPages'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/inscription" element={<Inscription />} />
        <Route path="/connexion" element={<Connexion />} />
        <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
        <Route path="/tableau-de-bord" element={<TableauDeBord />} />
        <Route path="/enfant/:id" element={<PageEnfant />} />
        <Route path="/acces-ecole" element={<AccesEcole />} />
        <Route path="/ecole/:id" element={<PageEcole />} />
        <Route path="/acces-therapeute" element={<AccesEtendu role="therapeute" />} />
        <Route path="/therapeute/:id" element={<PageTherapeutique />} />
        <Route path="/inscription-pro" element={<Navigate to="/annuaire" />} />
        <Route path="/connexion-pro" element={<Navigate to="/annuaire" />} />
        <Route path="/annuaire" element={<Annuaire />} />
        <Route path="/valider-pro" element={<Navigate to="/annuaire" />} />
        <Route path="/dashboard-pro" element={<Navigate to="/annuaire" />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  )
}
// rebuild mar. 31 mars 2026 23:03:27 CEST
